import AcousticPerfModal from "../components/modals/AcousticPerfModal";
import SigninModal from "../components/modals/SigninModal";
import SecuritySigninModal from "../components/modals/SecuritySigninModal";
import SignupModal from "../components/modals/SignupModal";
import PasswordResetModal from "../components/modals/PasswordResetModal";
import CreateEditorFolderModal from "../components/modals/CreateEditorFolderModal";
import CreateFolderModal from "../components/modals/CreateFolderModal";
import UpdateFolderModal from "../components/modals/UpdateFolderModal";
import DownloadFolderModal from "../components/modals/DownloadFolderModal";
import CreateModelModal from "../components/modals/CreateModelModal";
import EditorWelcomeModal from "../components/modals/EditorWelcomeModal";
import EditorValidationModal from "../components/modals/EditorValidationModal";
import AccountWelcomeModal from "../components/modals/AccountWelcomeModal";
import DeleteModelConfirmationModal from "../components/modals/DeleteModelConfirmationModal";
import DeleteFolderConfirmationModal from "../components/modals/DeleteFolderConfirmationModal";
import DeleteUserConfirmationModal from "../components/modals/DeleteUserConfirmationModal";
import ShareModelModal from "../components/modals/ShareModelModal";

export const MODAL_TYPES = {
  ACOUSTIC_PERF: "ACOUSTIC_PERF",
  SIGNIN: "SIGNIN",
  SECURITY_SIGNIN: "SECURITY_SIGNIN",
  SIGNUP: "SIGNUP",
  PASSWORD_RESET: "PASSWORD_RESET",
  CREATE_EDITOR_FOLDER: "CREATE_EDITOR_FOLDER",
  CREATE_FOLDER: "CREATE_FOLDER",
  UPDATE_FOLDER: "UPDATE_FOLDER",
  DELETE_FOLDER_CONFIRMATION: "DELETE_FOLDER_CONFIRMATION",
  DOWNLOAD_FOLDER: "DOWNLOAD_FOLDER",
  CREATE_MODEL: "CREATE_MODEL",
  DELETE_MODEL_CONFIRMATION: "DELETE_MODEL_CONFIRMATION",
  DELETE_USER_CONFIRMATION: "DELETE_USER_CONFIRMATION",
  EDITOR_WELCOME: "EDITOR_WELCOME",
  EDITOR_VALIDATION: "EDITOR_VALIDATION",
  ACCOUNT_WELCOME: "ACCOUNT_WELCOME",
  SHARE_MODEL: "SHARE_MODEL",
};

export const MODAL_COMPONENTS = {
  ACOUSTIC_PERF: AcousticPerfModal,
  SIGNIN: SigninModal,
  SECURITY_SIGNIN: SecuritySigninModal,
  SIGNUP: SignupModal,
  PASSWORD_RESET: PasswordResetModal,
  CREATE_EDITOR_FOLDER: CreateEditorFolderModal,
  CREATE_FOLDER: CreateFolderModal,
  UPDATE_FOLDER: UpdateFolderModal,
  DELETE_FOLDER_CONFIRMATION: DeleteFolderConfirmationModal,
  DOWNLOAD_FOLDER: DownloadFolderModal,
  CREATE_MODEL: CreateModelModal,
  DELETE_MODEL_CONFIRMATION: DeleteModelConfirmationModal,
  DELETE_USER_CONFIRMATION: DeleteUserConfirmationModal,
  EDITOR_WELCOME: EditorWelcomeModal,
  EDITOR_VALIDATION: EditorValidationModal,
  ACCOUNT_WELCOME: AccountWelcomeModal,
  SHARE_MODEL: ShareModelModal
};



// WEBPACK FOOTER //
// ./src/constants/modals.js